export const systemAuthorizationRouter = [
  {
    path: `/auth`,
    name: `auth`,
    redirect: `/auth/add`,
    hidden: true,
    component: () => import('@/views/Home'),
    children: [
      {
        path: '/auth/add',
        name: '/auth/add',
        component: () => import('@/views/systemAuthorization/UserAuth')
      }
    ]
  }
];
